import React from 'react'
import FAQ from '../components/Home/FAQ'
import Footer from '../components/Footer'
import MainProducts from '../components/Products/MainProducts'
import TopPicks from '../components/Products/TopPicks'
import ShopByCategory from '../components/Products/ShopByCategory'
import BestSellers from '../components/Products/BestSellers'
import LatestOffers from '../components/Products/LatestOffers'
import NewArrivals from '../components/Products/NewArrivals'
import Navbar from '../components/Navbar'

const Products = () => {
    return (
        <div className=''>
            <Navbar />
            <MainProducts />
            <TopPicks />
            <ShopByCategory />
            <BestSellers />
            <LatestOffers />
            <NewArrivals />
            <FAQ />
            <Footer />
        </div>
    )
}

export default Products